export interface PromoStatusProps {
  promoStatusId: number;
  promoStatusName: string;
  promoStatusKey: string;
}

export class PromoStatus {
  private readonly _promoStatusId: number;
  private readonly _promoStatusName: string;
  private readonly _promoStatusKey: string;

  constructor(props: PromoStatusProps) {
    this._promoStatusId = props.promoStatusId;
    this._promoStatusName = props.promoStatusName;
    this._promoStatusKey = props.promoStatusKey;
  }

  public get promoStatusId(): number {
    return this._promoStatusId;
  }

  public get promoStatusName(): string {
    return this._promoStatusName;
  }

  public get promoStatusKey(): string {
    return this._promoStatusKey;
  }
}
